import { render, staticRenderFns } from "./DraggableOfficeSignature.vue?vue&type=template&id=0a793380&"
import script from "./DraggableOfficeSignature.vue?vue&type=script&lang=js&"
export * from "./DraggableOfficeSignature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a793380')) {
      api.createRecord('0a793380', component.options)
    } else {
      api.reload('0a793380', component.options)
    }
    module.hot.accept("./DraggableOfficeSignature.vue?vue&type=template&id=0a793380&", function () {
      api.rerender('0a793380', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/pdf/components/DraggableOfficeSignature.vue"
export default component.exports